/*
 *
 * CheckpointFormDialog
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import AdvancedFormDialog from 'containers/AdvancedFormDialog';

import { CHECKPOINT_REQUESTS_FORM, CHECKPOINT_REQUESTS_FORM_DIALOG, CHECKPOINT_REQUESTS_TABLE_GRID } from './constants';
import { REQUESTS } from 'domain/Data/constants';

function CheckpointFormDialog({ form, detailContainer }) {
  return (
    <AdvancedFormDialog
      name={CHECKPOINT_REQUESTS_FORM_DIALOG}
      formName={CHECKPOINT_REQUESTS_FORM}
      advancedForm={form}
      dataTableName={CHECKPOINT_REQUESTS_TABLE_GRID}
      navigation={true}
      detailContainer={detailContainer}
      entityName={REQUESTS}
      addModeTitle="Новая заявка"
      editModeTitle="Изменение заявки"
      viewModeTitle="Просмотр заявки"
      copyModeTitle="Копирование заявки"
    />
  );
}

CheckpointFormDialog.propTypes = {
  form: PropTypes.node.isRequired,
};

export default CheckpointFormDialog;
